<template>
  <v-dialog :model-value="modelValue" width="500px">
    <v-card>
      <v-card-title>Scan product</v-card-title>
      <v-card-content>
        <v-container>
          <v-form ref="form">
            <v-row justify="center" align="center" class="mt-n2" >
                <v-col  class="d-flex justify-center align-center">
                  <BarcodeScanner v-if="scanActive" @detect="onDetect" @error="onError" />
                </v-col>
              </v-row>
          </v-form>
        </v-container>
      </v-card-content>
      <v-card-actions class="justify-space-between">
        <v-btn color="primary" @click="closeDialog">Annuler</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BarcodeScanner from "@/components/BarcodeScanner.vue";
import axiosInstance from "@/plugins/axios.js";
import snackbarService from '@/services/snackbarService.js';

export default {
  components: {
    BarcodeScanner,
  },
  props: {
    modelValue: Boolean,
    scanActive: Boolean,
    stockId: Number
  },
  data() {
    return {
      mandatoryRule: [(v) => !!v || "Mandatory field"],
      scanActive: true,
      searchedItem: {}
    };
  },
  methods: {
    closeDialog() {
      this.$emit("update:modelValue", false);
    },
    onDetect(code) {
      this.scanActive = false;
      this.searchProduct(code);
    },
    onError(error) {
      console.error(error);
    },

    async searchProduct(barcode){

      try {
        console.log("test")
        console.log(this.stockId)
        const response = await axiosInstance.get(`/UserStock/GetUserStockBarcode?barcode=${barcode}&stockId=${this.stockId}`);
        this.searchedItem = response.data.data[0];

        if(this.searchedItem != null){
        this.$emit('scan', this.searchedItem);
      }

      } catch (error) {
        snackbarService.showSnackbar(error.response.data.message, 'error');
        this.$emit("update:modelValue", false);
      } finally {
        this.loading = false;
      }
    },

  },
  watch: {
    modelValue(val) {
      if (val) {
        // Si le dialog s'ouvre, on active scanActive
        this.scanActive = true;
      } else {
        // Si le dialog se ferme, on désactive scanActive
        this.scanActive = false;
      }}
    }
};
</script>

<style>
#interactive.viewport {
  position: relative;
  width: 100%;
  height: auto;
}

#interactive.viewport > video {
  max-width: 100%;
  max-height: 100%;
}
</style>
